export const profile = {
  profileFavoritesIconTitle: 'Favoris',
  profileEditIconTitle: 'Éditer',
  profileShareIconTitle: 'Partager',
  profileAdditionalSectionTitle: 'Informations supplémentaires',
  profileFavoritesCurtainTitle: 'Favoris',
  profileFavoriteActionTitle: 'Ajouter aux favoris',
  profileFavoritedActionTitle: 'Ajouté aux favoris',
  profileMessageAction: 'Message',
  profileCurtainAdd: 'Ajouter',
  profileReportUser: "Signaler l'utilisateur",
  profileReportTitle: 'Signaler',
  profileReportSuccess: 'Contenu signalé',
  profileReset: 'Réinitialiser',
  profileApply: 'Appliquer',
  profileCustomInvalidEmail: "n'est pas une adresse email valide",
  profileMaxContentSizeError: 'Vous avez dépassé la taille maximale du contenu!',
  profileMaxAvatarSizeError: 'La taille de votre avatar est trop grande!',
  profileFavoritesCurtainSearchInputText: 'Chercher',
  profileTapShareCurtainOptionTitle: 'Copier le lien',
  profileTapShareLinkCopiedAlertTitle: 'Lien copié!',
  profileQrShareCurtainTitle: 'Partager le profil',
  profileQrShareCurtainShareButtonTitle: 'Partager',
  profileQrShareCurtainCopyButtonTitle: 'Copier le lien',
  profileQrShareCurtainCopiedAlertTitle: 'Lien copié!',
  profileQrTapShareProfileCurtainTitle: 'Partager votre profil',
  profileEditTitle: 'Éditer',
  profileEditPersonalSectionTitle: 'Informations personnelles',
  profileEditContactsSectionTitle: 'Contacts',
  profileEditSocialSectionTitle: 'Réseaux sociaux',
  profileEditAddSocialButtonTitle: 'Ajouter un réseau social',
  profileEditAdditionalSectionTitle: 'Informations supplémentaires',
  profileEditSaveButtonTitle: 'Enregistrer',
  profileEditSavedAlertTitle: 'Profil enregistré!',
  profileEditEmptyRequiredInputTitle: 'La valeur ne peut pas être vide',
  profileEditEmptyRequiredEmailInputTitle: "L'email public n'est pas une adresse email valide",
  profileEditEmptyRequiredErrorTitle: 'Quelque chose a mal tourné!',
  profileEditSocialsHint: "Veuillez insérer l'URL de votre profil social",
  preferences: 'Préférences',
  interestedIn: 'Intéressé par',
  expertIn: 'Je suis un expert en',
  myPitch: 'Mon pitch',
  qrBadge: 'Badge QR',
  touchpoints: 'Touchpoints',
  lookingFor: 'Je recherche',
  topicsToDiscuss: 'Sujets à discuter',
  createNew: 'Créer un nouveau',
  viewTopic: 'Voir le sujet',
  hobbyInterests: "Loisirs et centres d'intérêt",
  myNetwork: 'Mon réseau',
  seeAll: 'Voir tout',
  checkThemOut: 'Découvrez-les!',
  activities: 'Activités',
  oneOnOne: 'Rencontre 1:1',
  Leaderboard: 'Classement',
  learnNetworking: 'En savoir plus sur le Networking Hub',
  networkingGroup: 'Groupe de réseautage',
  networkingLevel: 'Niveau de réseautage',
  addNote: 'Ajouter une note',
  notes: 'Notes',
  enterNote: 'Entrez une note',
  shareUserProfile: 'Partager le profil utilisateur',
  flagUser: "Signaler l'utilisateur"
}
